import { useQuery, useMutation } from "@tanstack/react-query";
import api from "../axios-client";
import { queryClient } from "../query-client";

export const useGetModelAttributes = (modelId: string) =>
    useQuery({
        queryKey: ["models", modelId, "attributes"],
        queryFn: async () => {
            const response = await api.get(`/api/v1/models/${modelId}/attributes`);
            return response.data.data;
        },
        retry: false,
        staleTime: 1000 * 60 * 60,
        enabled: !!modelId,
    });

export const useCreateModelAttribute = (modelId: string) =>
    useMutation({
        mutationFn: async (data: any) => {
            const response = await api.post(`/api/v1/models/${modelId}/attributes`, data);
            return response.data.data;
        },
        onSuccess: () => {
            queryClient.refetchQueries({ queryKey: ["models", modelId, "attributes"] });
        },
    });

export const useUpdateModelAttribute = (modelId: string) =>
    useMutation({
        mutationFn: async ({ attributeId, data }: { attributeId: string; data: any }) => {
            const response = await api.put(`/api/v1/models/${modelId}/attributes/${attributeId}`, data);
            return response.data.data;
        },
        onSuccess: () => {
            queryClient.refetchQueries({ queryKey: ["models", modelId, "attributes"] });
        },
    });

export const useDeleteModelAttribute = (modelId: string) =>
    useMutation({
        mutationFn: async (attributeId: string) => {
            const response = await api.delete(`/api/v1/models/${modelId}/attributes/${attributeId}`);
            return response.data.data;
        },
        onSuccess: () => {
            queryClient.refetchQueries({ queryKey: ["models", modelId, "attributes"] });
        },
    });

export const useUpsertCanField = (modelId: string) =>
    useMutation({
        mutationFn: async ({ attributeId, data }: { attributeId: string; data: any }) => {
            const response = await api.put(`/api/v1/models/${modelId}/attributes/${attributeId}/can-field`, data);
            return response.data.data;
        },
        onSuccess: () => {
            queryClient.refetchQueries({ queryKey: ["models", modelId, "attributes"] });
        },
    });

export const useDeleteCanField = (modelId: string) =>
    useMutation({
        mutationFn: async (attributeId: string) => {
            const response = await api.delete(`/api/v1/models/${modelId}/attributes/${attributeId}/can-field`);
            return response.data.data;
        },
        onSuccess: () => {
            queryClient.refetchQueries({ queryKey: ["models", modelId, "attributes"] });
        },
    });

export const useUpdateCriticalStates = (modelId: string) =>
    useMutation({
        mutationFn: async ({ attributeId, data }: { attributeId: string; data: { criticalStates: any[] } }) => {
            const response = await api.put(`/api/v1/models/${modelId}/attributes/${attributeId}/critical-states`, data);
            return response.data.data;
        },
        onSuccess: () => {
            queryClient.refetchQueries({ queryKey: ["models", modelId, "attributes"] });
        },
    });
